import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppSelector } from '@core/Store/hooks'
import { getCurrentRacePageQueryKey } from '@core/Areas/RaceCard/Store/selectors'
import { useRaceFieldSummaryData } from '@core/Areas/RaceCardFixedOnly/Hooks/useRaceFieldSummaryData'
import { RacePageDataTransferObject } from '@mobi/api-types'
import { FieldsResults } from '@core/Areas/Racing/Components/FieldSummary/FieldsResults'

export const MatchedFieldSummaryResults: React.FC<{
  starterNumber: number
}> = ({ starterNumber }) => {
  const racePageQueryKey = useAppSelector(getCurrentRacePageQueryKey)
  const { data } = useQuery<RacePageDataTransferObject>({
    queryKey: racePageQueryKey || [],
    enabled: !!racePageQueryKey,
    staleTime: Infinity,
  })

  const { data: fieldSummary } = useRaceFieldSummaryData({
    racecourseSeq: data?.RacecourseSeq,
    selectionDate: data?.MeetingInformation.MeetingDate,
    raceNumber: data?.MeetingInformation.SelectedRace.RaceNumber,
  })

  return (
    <div>
      {fieldSummary?.fields
        .filter(itemField => itemField.starterNumber === starterNumber)
        .map(raceField => {
          return (
            <div data-testid='fields' key={starterNumber}>
              <FieldsResults summary={raceField} raceCode={fieldSummary?.raceCode} />
            </div>
          )
        })}
    </div>
  )
}
